import { BorderAllRounded } from "@mui/icons-material"

export const getAppPopupConfig = (mode: string) => {
  const isDark = mode === "dark"

  return {
    style: {
      backgroundColor: "transparent",
      color: isDark ? "#f8fafc" : "#0f172a",
      border: "none",
      boxShadow: "none",
      backdropFilter: "none",
      width: {
        xs: "calc(100% - 24px)",
        md: "calc(100% - 32px)",
      },
      maxWidth: 960,
      maxHeight: {
        xs: "calc(100dvh - 24px)",
        md: "calc(100dvh - 32px)",
      },
      borderRadius: {
        xs: 3,
        md: 4,
      },
      overflow: "hidden",
    },
    contentStyle: {
      minHeight: 0,
      m: 0,
      p: 5,
      borderRadius: 5,
      overscrollBehavior: "contain",
    },
  }
}

export const immersivePopupStyle = {
  mobileFullscreen: true,
  width: "100%",
  maxWidth: 1120,
  maxHeight: {
    xs: "100dvh",
    md: "calc(100dvh - 24px)",
  },
  contentStyle: {
    backgroundColor: "transparent",
    minHeight: 0,
    maxHeight: {
      xs: "100dvh",
      md: "calc(100dvh - 112px)",
    },
    m: 0,
    p: 0,
    display: "flex",
    flexDirection: "column",
  },
}

export const sponsorPopupStyle = {
  ...immersivePopupStyle,
  maxWidth: 980,
}

export const compactPopupStyle = {
  width: {
    xs: "calc(100% - 24px)",
    md: "100%",
  },
  maxWidth: 680,
  maxHeight: {
    xs: "calc(100dvh - 24px)",
    md: "calc(100dvh - 48px)",
  },
  contentStyle: {
    minHeight: 0,
    m: 0,
    p: 0,
    overflowY: "auto",
  },
}

export const qrFeedbackPopupStyle = {
  width: {
    xs: "calc(100% - 24px)",
    md: "100%",
  },
  maxWidth: 640,
  maxHeight: {
    xs: "calc(100dvh - 24px)",
    md: "calc(100dvh - 48px)",
  },
  backgroundColor: "transparent",
  border: "none",
  boxShadow: "none",
  backdropFilter: "none",
  overflow: "hidden",
  contentStyle: {
    minHeight: 0,
    m: 0,
    p: 0,
    display: "flex",
    backgroundColor: "transparent",
    overflow: "hidden",
    "& > div": {
      flex: 1,
      display: "flex",
      minHeight: 0,
    },
    "& > div > div": {
      flex: 1,
      display: "flex",
      minHeight: 0,
    },
  },
}

export const locationPopupStyle = {
  width: {
    xs: "calc(100% - 20px)",
    md: "calc(100% - 40px)",
  },
  maxWidth: 860,
  maxHeight: {
    xs: "calc(100dvh - 16px)",
    md: "calc(100dvh - 48px)",
  },
  borderRadius: {
    xs: 3,
    md: 4,
  },
  backdropOpacity: 0.62,
  contentStyle: {
    minHeight: 0,
    m: 0,
    p: { xs: 1.5, sm: 2.5 },
    overflowY: "auto",
    background: (theme: any) =>
      theme?.palette?.mode === "dark"
        ? "radial-gradient(circle at 8% 0%, rgba(38, 201, 132, 0.2) 0%, rgba(38, 201, 132, 0) 38%), linear-gradient(150deg, #15221d 0%, #0f1b17 100%)"
        : "radial-gradient(circle at 8% 0%, rgba(0, 154, 86, 0.18) 0%, rgba(0, 154, 86, 0) 35%), linear-gradient(145deg, #ffffff 0%, #f2fbf7 100%)",
    color: (theme: any) => (theme?.palette?.mode === "dark" ? "#d9f5e6" : "#10342a"),
    border: (theme: any) =>
      theme?.palette?.mode === "dark"
        ? "1px solid rgba(117, 209, 165, 0.32)"
        : "1px solid rgba(0, 154, 86, 0.22)",
    "& img[alt='winfacil-logo']": {
      opacity: (theme: any) => (theme?.palette?.mode === "dark" ? 0.08 : 0.18),
      filter: (theme: any) =>
        theme?.palette?.mode === "dark"
          ? "saturate(0.52) brightness(0.9) contrast(0.94)"
          : "saturate(0.85)",
    },
    "& .MuiPaper-root, & .MuiOutlinedInput-root, & .MuiInputBase-root": {
      backgroundColor: (theme: any) =>
        theme?.palette?.mode === "dark" ? "rgba(16, 33, 27, 0.88)" : undefined,
      borderColor: (theme: any) =>
        theme?.palette?.mode === "dark" ? "rgba(117, 209, 165, 0.34)" : "rgba(0, 154, 86, 0.2)",
      color: (theme: any) => (theme?.palette?.mode === "dark" ? "#d9f5e6" : undefined),
      "& .MuiSvgIcon-root": {
        color: (theme: any) => (theme?.palette?.mode === "dark" ? "#e7f7ef" : undefined),
      },
      "& .MuiInputLabel-root": {
        color: (theme: any) => (theme?.palette?.mode === "dark" ? "#bde9d1" : undefined),
      },
      "& .Mui-disabled": {
        color: (theme: any) =>
          theme?.palette?.mode === "dark" ? "rgba(222, 244, 232, 0.62) !important" : undefined,
      },
      "& fieldset": {
        borderColor: (theme: any) =>
          theme?.palette?.mode === "dark" ? "rgba(117, 209, 165, 0.34) !important" : undefined,
      },
    },
  },
}
